import React from 'react';
import Reveal from './Reveal';
import './ImageSlider.css';

function ImageSliderEn() {
  const slides = [
    { id: 1, image: 'slider-1.jpg' },
    { id: 2, image: 'slider-2.jpg' },
    { id: 3, image: 'slider-3.jpg' }
  ];

  return (
    <div className="image-slider">
      {slides.map((slide, index) => (
        <section key={slide.id} className="slider-section">
          <div 
            className="slider-background"
            style={{ 
              backgroundImage: `url(${process.env.PUBLIC_URL}/${slide.image})`
            }}
          >
            <div className="slider-overlay"></div>
          </div>
          {index === 0 && (
            <>
              <div className="slider-text-left">
                <Reveal>
                  <h2>Tabia, a constantly evolving business group</h2>
                </Reveal>
              </div>
              <div className="slider-text-bottom-right">
                <Reveal delay={200}>
                  <p>We support our portfolio companies as committed partners, with a focus on excellence and operational efficiency.</p>
                </Reveal>
              </div>
            </>
          )}
          {index === 1 && (
            <>
              <div className="slider-text-left">
                <Reveal>
                  <h2>Diversifying without borders</h2>
                </Reveal>
              </div>
              <div className="slider-text-bottom-right">
                <Reveal delay={200}>
                  <p>We work closely with each client to understand their specific needs and design tailored solutions that allow them to achieve their goals efficiently.</p>
                </Reveal>
              </div>
            </>
          )}
          {index === 2 && (
            <>
              <div className="slider-text-left">
                <Reveal>
                  <h2>A constantly evolving business group</h2>
                </Reveal>
              </div>
              <div className="slider-text-bottom-right">
                <Reveal delay={200}>
                  <p>We identify and manage strategic real estate investments with a patrimonial approach, aimed at generating solid and sustainable profitability, contributing economic and social value in the markets where we operate.</p>
                </Reveal>
              </div>
            </>
          )}
        </section>
      ))}
    </div>
  );
}

export default ImageSliderEn;
